import { UtilsDataService } from "src/app/services/utils-data.service";
import { Component, ElementRef, TemplateRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { VendorService } from "src/app/services/vendor.service";
import { SnackBarService } from "src/app/shared/services/snack-bar.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-support-documents",
  templateUrl: "./support-documents.component.html",
  styleUrl: "./support-documents.component.scss",
})
export class SupportDocumentsComponent {
  form!: FormGroup;

  selectedFileName: any;
  selectedFile: any;

  imageChangedEvent: any = "";
  croppedImage: any = "";
  photo_base64: any;

  fileBase64: string | null = null;

  isSaving = false;
  isImageSelected = false;
  isSectionDisabled = false;

  fileTypeErrorMsg = "";
  uploadedFiles: any = {};
  currentCropType: string = "";
  slug: string = "";
  showTaxFields = true;

  uploadSuccess: boolean = false;
  @ViewChild("fileInput") fileInput!: ElementRef;
  @ViewChild("errorDialog") errorDialog!: TemplateRef<any>;

  constructor(
    private fb: FormBuilder,
    private vendorService: VendorService,
    private snackbarService: SnackBarService,
    private utilsDataService: UtilsDataService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.initDocuments();
    // this.route.paramMap.subscribe(params => {
    //   console.log("params",params);

    //   this.slug = params.get('verify_key');  // Access the 'id' from the route
    // console.log("verify_key value", this.slug)
    // });
    console.log("uuid", this.utilsDataService.registredUuid);
  }

  ngOnInit() {
    if (this.isSectionDisabled) {
      this.form.disable();
    }

    this.route.queryParams.subscribe((params) => {
      let value = params["verify_key"];
      let skip = params["skip"];

      if (value) {
        value = value.replace(":key=", "");
      }

      this.slug = value || "";

      console.log("verify_key:", this.slug);
      console.log("verify_key:", skip);

      if (skip === "true") {
        this.onSkip();
      }
      else {
        this.getVendorDocuments(skip);
      }
    });
  }

  // getVendorDocuments() {
  //   let reqObj = {
  //     verify_key: this.slug,
  //   };

  //   this.vendorService.getVendorDocumentsB4Approval(reqObj).subscribe({
  //     next: (res: any) => {
  //       console.log("Vendor Documents:", res);

  //       if (!res?.data) return;

  //       this.utilsDataService.registredUuid = res.data.verify_key;

  //       const documents = res.data.documents || [];

  //       if (documents.length) {
  //         documents.forEach((doc: any) => {
  //           let key = "";
  //           let formField = "";
  //           let comments = "";

  //           if (doc.type === "GST") {
  //             key = "gst";
  //             formField = "gstNumber";
  //             comments = ""
  //           }

  //           if (doc.type === "CIN") {
  //             key = "cin";
  //             formField = "cinNumber";
  //           }

  //           if (doc.type === "PAN") {
  //             key = "pan";
  //             formField = "panNumber";
  //           }

  //           if (doc.type === "OTHR") {
  //             key = "other";
  //             formField = "otherNumber";
  //           }

  //           if (formField) {
  //             this.form.patchValue({
  //               [formField]: doc.ref_id_no,
  //             });

  //             if (doc.status === 'A') {
  //               this.form.get(formField)?.disable();
  //             }

  //             if (doc.status === 'R') {
  //               this.form.get(formField)?.enable();
  //             }
  //           }

  //           // ✅ Store uploaded file info
  //           if (key) {
  //             this.uploadedFiles[key] = {
  //               fileName: "",
  //               base64Data: "",
  //               comments: doc.admin_comments,
  //               filePath: `${doc.file_path}/${doc.file_name}`,
  //             };
  //           }
  //         });
  //       }
  //     },

  //     error: (err: any) => {
  //       console.error("API Error:", err);

  //       this.snackbarService.open(
  //         err?.supportMessage || "Failed to load documents",
  //         "close",
  //         3000,
  //         "center",
  //         "top",
  //       );
  //     },
  //   });
  // }


  getVendorDocuments(obj: any) {



    let reqObj = {
      verify_key: this.slug,
      skip: obj,
    };

    console.log('Request Object:', reqObj);

    this.vendorService.getVendorDocumentsB4Approval(reqObj).subscribe((resp: any) => {

      if (resp.statusCode === 200) {
        if (!resp?.data) return;

        this.utilsDataService.registredUuid = resp.data.verify_key;

        const documents = resp.data.documents || [];


        if (documents.length) {
          documents.forEach((doc: any) => {
            let key = "";
            let formField = "";
            let comments = "";

            if (doc.type === "GST") {
              key = "gst";
              formField = "gstNumber";
              comments = ""
            }

            if (doc.type === "CIN") {
              key = "cin";
              formField = "cinNumber";
            }

            if (doc.type === "PAN") {
              key = "pan";
              formField = "panNumber";
            }

            if (doc.type === "OTHR") {
              key = "other";
              formField = "otherNumber";
            }

            if (formField) {
              this.form.patchValue({
                [formField]: doc.ref_id_no,
              });

              if (doc.status === 'A') {
                this.form.get(formField)?.disable();
              }

              if (doc.status === 'R') {
                this.form.get(formField)?.enable();
              }
            }

            // ✅ Store uploaded file info
            if (key) {
              this.uploadedFiles[key] = {
                fileName: "",
                base64Data: "",
                comments: doc.status === 'R' ? doc.admin_comments : '',
                filePath: `${doc.file_path}/${doc.file_name}`,
              };
            }
          });
        }




        // Show first 5 initially
      }

    });
  }



  initDocuments() {
    this.form = this.fb.group({
      gstNumber: ["", [this.gstValidator()]],
      cinNumber: ["", [this.cinValidator()]],
      panNumber: ["", [this.panValidator()]],
      otherNumber: [""],
    });
  }

  prepareDocuments() {

    const docsConfig = [
      { type: "GST", number: this.form.value.gstNumber, key: "gst" },
      { type: "CIN", number: this.form.value.cinNumber, key: "cin" },
      { type: "PAN", number: this.form.value.panNumber, key: "pan" },
      { type: "OTHR", number: this.form.value.otherNumber, key: "other" },
    ];

    return docsConfig
      .filter(doc => doc.number && this.uploadedFiles[doc.key]?.base64Data)
      .map(doc => ({
        type: doc.type,
        module_name: "JOBS",
        ref_id_no: doc.number,
        file_name: this.uploadedFiles[doc.key].fileName,
        base64Data: this.uploadedFiles[doc.key].base64Data
      }));
  }

  onSubmit() {

    if (this.isSaving) return;

    const documents = this.prepareDocuments();

    if (documents.length === 0) {
      this.snackbarService.open(
        "Please upload at least one document",
        "close",
        3000,
        "center",
        "top"
      );
      return;
    }

    this.isSaving = true;

    const payload = {
      has_tax_documents: "yes",
      doc_status: "Y",
      verify_key: this.utilsDataService.registredUuid,
      documents: documents
    };

    this.vendorService.uploadVendorDocuments(payload).subscribe({
      next: (res: any) => {

        this.snackbarService.open(
          res?.supportMessage || res?.message || "Documents uploaded successfully",
          "close",
          3000,
          "center",
          "top"
        );

        this.uploadSuccess = true;
        this.isSaving = false;

      },
      error: (err: any) => {

        this.snackbarService.open(
          err?.error?.supportMessage || "Upload failed",
          "close",
          3000,
          "center",
          "top"
        );

        this.isSaving = false;
      }
    });
  }

  handleFileInput(event: any, type: string) {
    const file = event.target.files[0];

    if (!file) return;

    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const maxSize = 1 * 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      this.fileTypeErrorMsg = "Only JPEG, JPG, PDF, DOCX or PNG allowed";
      this.openErrorDialog(this.fileTypeErrorMsg);
      return;
    }

    if (file.size > maxSize) {
      this.fileTypeErrorMsg = "File size exceeds 1MB";
      this.openErrorDialog(this.fileTypeErrorMsg);
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const base64 = (reader.result as string).split(",")[1];

      this.uploadedFiles[type] = {
        fileName: file.name,
        base64Data: base64,
        filePath: reader.result,
      };
    };

    reader.readAsDataURL(file);
  }

  imageCropped(event: any) {
    const base64 = event.base64.split(",")[1];
    this.croppedImage = event.base64;
    this.uploadedFiles[this.currentCropType].base64Data = base64;
  }

  convertObjectUrlToBase64(objectUrl: string) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", objectUrl, true);
    xhr.responseType = "blob";

    xhr.onload = () => {
      const reader = new FileReader();

      reader.onloadend = () => {
        this.croppedImage = reader.result;
        this.photo_base64 = reader.result?.toString().split(",")[1];
      };

      reader.readAsDataURL(xhr.response);
    };

    xhr.send();
  }

  panValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

      if (!control.value) return null;

      return regex.test(control.value) ? null : { invalidPan: true };
    };
  }

  cinValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const regex =
        /^([LU]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/;

      if (!control.value) return null;

      return regex.test(control.value) ? null : { invalidCin: true };
    };
  }

  gstValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

      if (!control.value) return null;

      return regex.test(control.value.toUpperCase())
        ? null
        : { invalidGst: true };
    };
  }

  openErrorDialog(msg: string) {
    this.dialog.open(this.errorDialog, {
      data: { message: msg },
    });
  }

  viewDetails(obj: any) {
    if (obj.file_path && obj.file_name) {
      return `${obj.file_path}/${obj.file_name}`;
    }

    return "assets/images/default.png";
  }

  isImage(fileName: string) {
    return /\.(jpg|jpeg|png|gif)$/i.test(fileName);
  }

  isAnyDocumentValid(): boolean {
    const docs = [
      { type: "gst", number: this.form.value.gstNumber },
      { type: "cin", number: this.form.value.cinNumber },
      { type: "pan", number: this.form.value.panNumber },
      { type: "other", number: this.form.value.otherNumber },
    ];

    return docs.some((doc) => doc.number && this.uploadedFiles[doc.type]);
  }

  onSkip() {




    const payload = {
      doc_status: "N",
      verify_key: this.slug,
      documents: []
    };

    this.vendorService.uploadVendorDocuments(payload).subscribe({
      next: () => {
        this.router.navigate(['/vendor-success']);

      }
    });

  }

}
